<template>
  <div class="footer">
    <p>Copyright © 2021-2032 北京明世继元招标有限公司 版权所有</p>
    <p>京ICP备05008466号-1</p>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return {}
  },
  methods: {},
  mounted() {
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.footer
  background #2c367e
  padding 35px 0
  text-align center
  min-width 1200px
  p
    font-size 12px
    color #999
    line-height 25px
</style>



// WEBPACK FOOTER //
// src/assets/components/Footer.vue